import { useOutletContext } from "react-router"

import type { Site } from "@/models/site"

export interface SiteLayoutContext {
  orgId?: string
  site: Site | null
}

export const useSiteLayoutContext = (): SiteLayoutContext =>
  useOutletContext<SiteLayoutContext>()
